import { render } from "./HeaderSilo.vue?vue&type=template&id=30981e1f&scoped=true"
import script from "./HeaderSilo.vue?vue&type=script&lang=js"
export * from "./HeaderSilo.vue?vue&type=script&lang=js"

import "./HeaderSilo.vue?vue&type=style&index=0&id=30981e1f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30981e1f"]])

export default __exports__